<template>
  <div class="indexcenter">
    <div class="WidthFixed">
      <div class="RouterTab">
        <div class="RouterTabName">
          <div class="RouterName" v-for="(item , index) of IndexCenterTab" :class="[  onChage == index ? 'RouterNameActivation' : 'RouterNameNoActivation' ]" :key="index" @click="TabClick(item,index)">
            {{item.name}}
            <div class="line"></div>
          </div>
        </div>
      </div>
      <div class="routerViwe">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import ProcurementIndexFrom from './FormData/ProcurementIndexFrom'

export default {
  data() {
    return {
      IndexCenterTab: [
        {
          name: '采购指标',
          routerURL: '/ProcurementIndex'
        },
        {
          name: '销售指标',
          routerURL: '/SalesIndicators'
        },
        {
          name: '库存透视',
          routerURL: '/InventoryPerspective'
        }
      ],
      onChage: 0
    }
  },
  mounted() {
  },
  methods: {
    // 路由跳转
    TabClick(item, index) {
      if (this.onChage != index) {
        this.onChage = index
      }
      console.log(item);
      this.$router.push({
        path: '/IndexCcenter' + item.routerURL + '?NodeID=63'
      })
    },

  },
  watch: {
    $route: {
      handler(to, from) {
        console.log(to);
       
        if (to.name == 'procurementIndex') {
          this.onChage = 0
          this.$nextTick(function () {
            ProcurementIndexFrom[5].inputflag = false
          })

        } else if (to.name == 'salesIndicators') {
          this.onChage = 1
          this.$nextTick(function () {
            ProcurementIndexFrom[5].inputflag = true
          })

        } else {
          this.onChage = 2
        }
        console.log(ProcurementIndexFrom, 'ProcurementIndexFrom');
        if (to.query.to == "") {
          this.onChage = 0
          this.$router.push({
            path: '/IndexCcenter/ProcurementIndex',
            query: {
              NodeID: "63",

            }
          })
        }
      },
      immediate: true
    },
    // 监听页面进入时自动跳转指定页面
    onChage: {
      handler(newonChage, oldonChage) {
        if (newonChage == 0) {
          // this.$router.push({
          //   path: '/IndexCcenter/ProcurementIndex?NodeID=63'
          // })
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="less">
.RouterNameActivation {
  color: #e71d43;
}
.RouterNameNoActivation {
  color: #86909c;
}
.indexcenter {
  width: 100%;
  height: 100%;
  .WidthFixed {
    width: 1200px;
    // height: 650px;
    min-height: 650px;
    margin: 0px auto 50px auto;
    position: relative;
    // outline: 1px solid red;
    top: 20px;

    .RouterTab {
      width: 100%;
      height: 38px;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      //   outline: 1px solid red;
      display: flex;
      justify-content: center;
      align-content: center;
      position: relative;

      .RouterTabName {
        display: flex;
        justify-content: center;
        align-content: center;
        position: relative;
      }

      .RouterName {
        // width: 64px;
        height: 22px;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        position: relative;
        top: 20%;
        margin-left: 50px;
        margin-right: 50px;
        cursor: pointer;

        .line {
          width: 2px;
          height: 12px;
          background: #e5e6eb;
          border-radius: 0px 0px 0px 0px;
          opacity: 1;
          position: absolute;
          top: 4px;
          left: 115px;
        }
      }
      .RouterName:nth-last-child(1) {
        .line {
          background: #fff;
        }
      }
    }
  }
}
</style>